'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _blacklist = require('blacklist');

var _blacklist2 = _interopRequireDefault(_blacklist);

var _reactMixin = require('react-mixin');

var _reactMixin2 = _interopRequireDefault(_reactMixin);

var _Kepler = require('../Kepler');

var _mixin = require('../mixin');

var _mixin2 = _interopRequireDefault(_mixin);

var _lodashGet = require('lodash.get');

var _lodashGet2 = _interopRequireDefault(_lodashGet);

var _lodashPick = require('lodash.pick');

var _lodashPick2 = _interopRequireDefault(_lodashPick);

var _lodashSetwith = require('lodash.setwith');

var _lodashSetwith2 = _interopRequireDefault(_lodashSetwith);

var components = {
    select: _Kepler.Select,
    checkbox: _Kepler.CheckboxGroup,
    radio: _Kepler.RadioGroup,
    textInput: _Kepler.Input,
    freeText: _Kepler.Input
};

var question = _propTypes2['default'].shape({
    key: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]).isRequired,
    value: _propTypes2['default'].string.isRequired,
    type: _propTypes2['default'].oneOf(['select', 'checkbox', 'radio', 'textInput', 'freeText']).isRequired,
    answers: _propTypes2['default'].arrayOf(answer)
});

var answer = _propTypes2['default'].shape({
    key: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]).isRequired,
    value: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]).isRequired,
    questions: _propTypes2['default'].arrayOf(question)
});

var Survey = (function (_React$Component) {
    _inherits(Survey, _React$Component);

    function Survey(props) {
        _classCallCheck(this, Survey);

        _get(Object.getPrototypeOf(Survey.prototype), 'constructor', this).call(this, props);
        this.displayName = 'Survey';
    }

    _createClass(Survey, [{
        key: 'getQuestions',
        value: function getQuestions(answer, response) {
            var questions = answer.questions;

            if (!answer.questions) {
                return [];
            }

            switch (typeof response) {
                case 'string':
                    return response === answer.key ? questions : [];
                case 'object':
                    {
                        if (Array.isArray(response)) {
                            return response.indexOf(answer.key) !== -1 ? questions : [];
                        } else {
                            return response[answer.key] ? questions : [];
                        }
                    }
                default:
                    return [];
            }
        }
    }, {
        key: 'getResponse',
        value: function getResponse(question, response, responseBase) {
            var value = (0, _lodashGet2['default'])(response, responseBase.join('.'));

            switch (typeof value) {
                case 'string':
                    return question.type === 'checkbox' ? value.split(',') : value;
                case 'object':
                    return this.getResponse(question, value, [question.key]);
                default:
                    return value;
            }
        }
    }, {
        key: 'renderQuestion',
        value: function renderQuestion(question, response, responseBase) {
            var _this = this;

            return _react2['default'].createElement(
                _Kepler.FormField,
                { key: question.key, label: question.value },
                _react2['default'].createElement(components[question.type], this.buildProps(question, response, responseBase)),
                question.answers && question.answers.map(function (answer) {
                    var responseTransform = _this.cloneObject(responseBase);
                    var questions = _this.getQuestions(answer, _this.getResponse(question, response, responseBase));
                    responseTransform.push(answer.key);

                    return _this.renderQuestions(questions, response, responseTransform);
                })
            );
        }
    }, {
        key: 'renderQuestions',
        value: function renderQuestions(questions, response, responseBase) {
            var _this2 = this;

            return questions.map(function (question) {
                var responseTransform = _this2.cloneObject(responseBase);
                responseTransform.push(question.key);

                return _this2.renderQuestion(question, response, responseTransform);
            });
        }
    }, {
        key: 'buildOptions',
        value: function buildOptions(question) {
            return question.answers.map(function (answer) {
                return {
                    value: answer.key,
                    label: answer.value
                };
            });
        }
    }, {
        key: 'setResponse',
        value: function setResponse(response, path, value, question) {
            var expValue = (0, _lodashGet2['default'])(response, path),
                keys = Array.isArray(value) ? this.cloneObject(value) : [value];

            keys.push(question.key);
            expValue = typeof expValue === 'object' ? _extends({}, (0, _lodashPick2['default'])(expValue, keys), _defineProperty({}, question.key, value)) : value;

            (0, _lodashSetwith2['default'])(response, path, expValue, function (nsValue, key, nsObject) {
                if (typeof nsValue !== 'object') {
                    return _defineProperty({}, key, nsValue);
                }
            });

            return response;
        }
    }, {
        key: 'onChange',
        value: function onChange(question, response, responseBase) {
            var _this3 = this;

            var clonedResponse = this.cloneObject(response);

            return function (value) {
                /**
                * Pattern matches string which doesn't have
                * 1. :::: (4 consecutive colon) and
                * 2. |||| (4 consecutive pipeline)
                */
                var surveyRegExp = /^((?!(:{4}|\|{4})).)*$/;

                var path = _this3.cloneObject(responseBase);
                value = Array.isArray(value) ? value.join(',') : value;
                path = path.join('.');

                _this3.setResponse(clonedResponse, path, value, question);

                return surveyRegExp.test(value) && _this3.props.onChange(clonedResponse);
            };
        }
    }, {
        key: 'buildProps',
        value: function buildProps(question, response, responseBase) {
            var props = (0, _blacklist2['default'])(question, 'key', 'value', 'values', 'type', 'answers');

            switch (question.type) {
                case 'select':
                    {
                        return _extends({
                            value: this.getResponse(question, response, responseBase),
                            options: this.buildOptions(question),
                            onChange: this.onChange(question, response, responseBase)
                        }, props);
                    }
                case 'checkbox':
                    {
                        return _extends({
                            values: this.getResponse(question, response, responseBase),
                            options: this.buildOptions(question),
                            onChange: this.onChange(question, response, responseBase)
                        }, props);
                    }
                case 'radio':
                    {
                        return _extends({
                            value: this.getResponse(question, response, responseBase),
                            options: this.buildOptions(question),
                            onChange: this.onChange(question, response, responseBase)
                        }, props);
                    }
                case 'textInput':
                    {
                        return _extends({
                            value: this.getResponse(question, response, responseBase),
                            onChange: this.onChange(question, response, responseBase)
                        }, props);
                    }
                case 'freeText':
                    {
                        return _extends({
                            value: this.getResponse(question, response, responseBase),
                            multiline: true,
                            onChange: this.onChange(question, response, responseBase)
                        }, props);
                    }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var response = this.props.response;

            var responseBase = [];

            return _react2['default'].createElement(
                _Kepler.Form,
                { type: 'basic', id: this.props.id },
                this.renderQuestions(this.props.survey, response, responseBase)
            );
        }
    }]);

    return Survey;
})(_react2['default'].Component);

Survey.propTypes = {
    survey: _propTypes2['default'].arrayOf(question).isRequired,
    response: _propTypes2['default'].object,
    onChange: _propTypes2['default'].func.isRequired,
    errors: _propTypes2['default'].object,
    id: _propTypes2['default'].string
};

Survey.defaultProps = {
    response: {}
};

(0, _reactMixin2['default'])(Survey.prototype, _mixin2['default']);

module.exports = Survey;


//////////////////
// WEBPACK FOOTER
// /causemisspiggynodeweb-ci-9188/workspace/Release/~/kepler/lib/components/Survey.js
// module id = 334
// module chunks = 0